var map = {
	"./ic_btc_40.svg": 252,
	"./ic_dai_40.svg": 253,
	"./ic_eth_40.svg": 176,
	"./ic_frax_40.svg": 254,
	"./ic_link_40.svg": 255,
	"./ic_uni_40.svg": 256,
	"./ic_usdc_40.svg": 257,
	"./ic_usdt_40.svg": 258,
	"./ic_weth_40.svg": 259
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 575;